// src/components/Dashboard.jsx
import React, { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Sidebar from "./Sidebar";

const Dashboard = () => {
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loginUser) {
      navigate("/login"); // Redirect to login if no user is logged in
    }
  }, [loginUser, navigate]);

  if (!loginUser) {
    return null; // Don't render anything while redirecting
  }
 
  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar - Let it handle its own responsive behavior */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Main scrollable content */}
        <main className="flex-1 overflow-auto">
          <div className="mt-12 p-4 sm:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;